module.exports = __webpack_public_path__ + "img/product_7.988b0a4.webp";